module.exports = __webpack_public_path__ + "img/sd-cards.85e4a5dc.svg";